import {AssistanceService} from './assistanceservice';
import {Currency} from './currency';
import { Assistance } from './assistance';

export class AssistancePlan {
  id?: number;
  name?: string;
  assistance_id?: number;
  coverage_name?: number;  
  currency_id?: number;
  base_price?: string;
  life_months?: number;
  status?: number;
  services?: AssistanceService[];
  currency?: Currency;
  is_new?: boolean;
  active_flag?: boolean;
  currency_synbol: string;
  arrear_months: number;
  text: string;
  email_info_id: number;
  attachment_id: number;
  programmed_sms: string;
  product: Assistance;
  active_months:any;
  facturacion?:any;
  code_equivalence_chubb?: any;
  //--agrego el nuevo campo project_sap
  project_sap?:string; 
  buca_plan: number=0;
  sinister_plan: number=0;
  is_retention_plan: number=0;
  is_retention_plan_assistance: number = 0;
  renewal_expiration_date: number=0;
  apply_retention_tax: number = 0;
  send_kit_new_sale?: any;
  buca_apply_action?: any;
  sinister_apply_action?: any;
  member_classification?: number;
}
